import { render, staticRenderFns } from "./ShowProductsPage.vue?vue&type=template&id=7b28f5c9&"
import script from "./ShowProductsPage.vue?vue&type=script&lang=js&"
export * from "./ShowProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports